'use strict';

var Hyperlink = require('../Hyperlink-e5b9a045.js');
var _tslib = require('../_tslib-17936c8d.js');
var React = require('react');
var styled = require('styled-components');
var Spacing = require('../Spacing-3105a516.js');
var styles = require('../styles-2eec2580.js');
require('../ResponsiveSizes-61db354a.js');
require('../ArrowDown-74f74169.js');
require('../UseSize-b7bfbcb4.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);
var styled__default = /*#__PURE__*/_interopDefault(styled);

var CrossedLineText = function (props) { return (React__namespace.createElement(Spacing.Flex, { style: { width: '100%' }, justify: Spacing.FlexJustify.CENTER, align: Spacing.FlexAlign.CENTER },
    React__namespace.createElement(HorizontalLine, null),
    React__namespace.createElement(Spacing.Spacing, { horizontal: true },
        React__namespace.createElement(Hyperlink.Text, { type: props.textType, useCompact: true, align: "center" },
            React__namespace.createElement("span", null, props.children))),
    React__namespace.createElement(HorizontalLine, null))); };
var HorizontalLine = styled__default.default.div.withConfig({ displayName: "HorizontalLine", componentId: "-5fzlfv" })(templateObject_1 || (templateObject_1 = _tslib.__makeTemplateObject(["\n  border-top: 1px solid ", ";\n  flex-grow: 1;\n"], ["\n  border-top: 1px solid ", ";\n  flex-grow: 1;\n"])), styles.themeColors.gray['30']);
var templateObject_1;

exports.Hyperlink = Hyperlink.Hyperlink;
exports.InlineText = Hyperlink.InlineText;
exports.Text = Hyperlink.Text;
Object.defineProperty(exports, 'TextSpacingType', {
  enumerable: true,
  get: function () { return Hyperlink.TextSpacingType; }
});
Object.defineProperty(exports, 'TextType', {
  enumerable: true,
  get: function () { return Hyperlink.TextType; }
});
exports.textSelectors = Hyperlink.textSelectors;
exports.CrossedLineText = CrossedLineText;
//# sourceMappingURL=index.js.map
